import styled from "styled-components";

import { color } from "../../theme/color";
import { Hidden } from "./controls";
import { TextField } from "./TextField";

type SearchBoxProps = {
    label: string;
    placeholder?: string;
    value: string;
    autoFocus?: boolean;
    className?: string;
    onChange(value: string): void;
};

/** A search field, with a label that screen readers read. */
export function SearchBox({ label, placeholder = label, className, ...field }: SearchBoxProps) {
    return (
        <label className={className}>
            <Hidden>{label}</Hidden>
            <Field type="search" placeholder={placeholder} {...field} />
        </label>
    );
}

const Field = styled(TextField)`
    border: 0;
    background: ${color.surface};
`;
